import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import PropTypes from "prop-types";
import Picker from 'react-month-picker'
import {getListaMesesTexto} from "../../../utils/functions";
require('react-month-picker/css/month-picker.css');

@inject("store")
@observer
export class MonthPicker extends Component {
    static propTypes = {
        value: PropTypes.object.isRequired,
        years: PropTypes.array,
        lang: PropTypes.object,
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        value: { years: null, month: null },
        years: _.range(1980, (new Date()).getFullYear() + 1),
        lang: {
            months: getListaMesesTexto(),
            from: 'De',
            to: 'Até'
        }
    };

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Picker
                ref="pickAMonth"
                years={this.props.years}
                value={this.props.value}
                lang={this.props.lang.months}
                onChange={(year, month) => this.props.onChange({ year, month })}
            >
                <div className="box" onClick={() => this.refs.pickAMonth.show()}>
                    <label>{this.getLabel(this.props.value)}</label>
                    { this.props.value && this.props.value.year && this.props.value.month &&
                        <span className="clear-zone" title="Clear all" aria-label="Clear all"
                                 onClick={() => this.props.onChange({ year: null, month: null })}
                        >
                            <span className="clear">×</span>
                        </span>
                    }
                </div>
            </Picker>
        )
    }

    getLabel = (value) => {
        if (value && value.year && value.month) {
            return (this.props.lang.months[value.month - 1] + "/" + value.year);
        }

        return "";
    }
}
